import { genericGet } from '../../config/api/apiMethods';
import { ShopResponseType } from '../../types/shop';
import { fetchShopListEndpoint } from './endpoints';

const fetchShopList = (filter?: string) =>
  genericGet<ShopResponseType>(fetchShopListEndpoint(filter));

export { fetchShopList };
